/**
 * 데이터 형식
{
  date: '', //YYYY-MM-DD
  items: [ // 변경 유형 별 객체 배열
    {
      type: '', // 변경 유형(신규/버전 추가: 'Added', 변경: 'Changed', 버그 수정: 'Fixed', 미지원: 'Removed', 문서 수정:'Docs')
      summary: <></>, // 변경 내용 요약
      apis: [ // 변경 유형에 해당하는 API 배열, 변경사항이 전체 적용인경우(ex.에러 응답 포맷 변경) 빈배열도 가능
          {
            authorized_sol_ser: '',  // 권한별 노출, 필요없다면 제거 (주문금액분할모듈업체: 'cal_state_per_prod')
            authorized_aff_no: [],  // 제휴사번호별 노출, 필요없다면 제거 (신세계푸드: 1208)
            method: '',
            action: '',
            detail: <></> // API 별 상세 설명, 필요없다면 제거
          }
      ]
    },
  ]
}
*/

const release2026 = [
  {
    date: '2026-10-28',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          카테고리 조회 API 에 쿠팡 필수옵션 조회 기능 추가 (<code>opt_yn</code> 파라미터)
        </>,
        apis: [
          {
            method: 'GET',
            action: '/categorys',
            detail:
            <>
              - 요청: <code>opt_yn</code>(필수옵션 전달 여부) 파라미터 추가. <code>true</code> 전달 시에만 포함<br />
              - 응답: 쿠팡(B378) 매칭 카테고리에 <code>has_required_opt</code>/<code>required_opt_list</code>(필수옵션), <code>has_group_opt</code>/<code>group_opt_list</code>(필수그룹옵션, 그룹별 택1) 추가<br />
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-10-23',
    items: [
      {
        type: 'Docs',
        summary:
        <>
          단일상품(<code>std_ol_yn</code>) 등록이 가능한 쇼핑몰 안내가 실제 지원 목록과 달라 정정하였습니다. <b>API 동작 변경은 없습니다.</b><br />
          <b>쿠팡</b>, <b>GSSHOP</b>, <b>테무</b>, <b>타다닥</b>, <b>알리 익스프레스 글로벌</b>, <b>스마트스토어</b>, <b>홈플러스</b>, <b>알리바바</b>, <b>알리 익스프레스</b>, <b>토스쇼핑</b> 이 안내에서 누락되어 있었습니다.
          <br/>해당 쇼핑몰은 <b>기존에도 단일상품 등록이 가능</b>했으며 안내 문구만 갱신되지 않은 것입니다.<br />
          반대로 <b>롯데슈퍼</b> 는 단일상품 등록을 지원하지 않으나 안내에 포함되어 있어 제외하였습니다.<br />
          에러 코드 <code>e4040</code> <b>단일상품 등록은 다음의 쇼핑몰만 가능합니다.</b> 의 쇼핑몰 목록도 동일하게 갱신하였습니다.
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add/v1.2',
            detail:
            <>
              <b>온라인상품 등록</b> 의 <code>std_ol_yn</code> 설명에 <b>단일상품 등록이 가능한 쇼핑몰 목록</b>을 추가하였습니다.<br />
              - <code>std_ol_yn</code> 은 <code>site_list</code> 전체에 동일하게 적용됩니다. 쇼핑몰별로 다르게 지정할 수 없으므로 단일상품과 일반상품을 한 요청에 섞어 등록할 수 없습니다.<br />
              - <b>쿠팡</b> 은 단일상품만 지원하며 <code>opt_type</code> 이 <code>조합형</code> 인 경우에만 등록됩니다. 옵션없음·독립형 옵션·추가구매옵션은 등록할 수 없습니다.
            </>
          },
          {
            method: 'POST',
            action: '/products/add/v1.1',
            detail:
            <>
              <b>온라인상품 등록</b> 의 <code>std_ol_yn</code> 설명에 v1.2 와 동일한 내용을 추가하였습니다.
            </>
          },
        ]
      },
      {
        type: 'Docs',
        summary:
        <>
          주문 조회 API 의 <code>bundle_yn</code> 설명에 묶음번호 생성 시점을 추가하고 조회 단위 설명을 보강하였습니다. <b>API 동작 변경은 없습니다.</b><br />
          묶음번호는 주문이 <b>신규주문 상태가 될 때</b> 생성되며, <b>결제완료(발주확인 전) 상태의 주문은 묶음번호가 없습니다.</b> 합포장 대상이 아닌 단건 주문도 해당 주문만의 묶음번호가 부여됩니다.<br />
          <code>bundle_yn</code> 이 <code>true</code> 이면 묶음번호가 있는 주문만 묶음 단위로, <code>false</code> 이면 묶음번호 유무와 관계없이 주문 한 건씩 조회하며, start·length·recordsTotal 도 각각 그 단위를 기준으로 합니다.
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          },
          {
            method: 'POST',
            action: '/order/detail-list',
          }
        ]
      },
    ]
  },
  {
    date: '2026-10-22',
    items: [
      {
        type: 'Added',
        summary:
        <>
          출고완료 API가 추가되었습니다.
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/order/unstoring/complete',
            detail:
            <>
              입력한 묶음번호 중 주문상태가 <code>출고대기</code>·<code>출고보류</code>·<code>운송장출력</code>이고 택배사·송장번호가 입력된 주문을 출고완료 처리합니다.<br />
              - Response 의 <code>total</code>(대상 주문수)·<code>success</code>(성공 주문수)·<code>fail</code>(실패 주문수)로 처리 결과를 확인할 수 있습니다.
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-10-15',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          조합형 옵션의 단계가 3단에서 5단으로 확장되었습니다. (옵션 <code>4</code>·<code>5</code> 단 추가)<br />
          단, 옵션 4·5단은 옵션 5개를 지원하는 쇼핑몰에 연동하는 경우에만 사용할 수 있습니다.<br />
          SKU상품의 속성도 3단에서 5단으로 확장되었습니다.
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add/v1.2',
            detail:
            <>
              <b>온라인상품 등록</b> 요청의 조합형 옵션에 옵션명 <code>opt_sort4</code>·<code>opt_sort5</code>, 옵션값 <code>opt_sort4_desc</code>·<code>opt_sort5_desc</code> 가 추가되었습니다.<br />
              - 옵션 4·5단은 연동 쇼핑몰이 옵션 5개 지원 쇼핑몰일 때만 입력할 수 있습니다. 미지원 쇼핑몰의 옵션은 최대 3단까지만 허용되며, 초과 시 <code>옵션은 최대 3개까지 사용할 수 있습니다.</code> 오류가 반환됩니다.<br />
              - 추가된 4·5단은 모두 선택 입력값이며, 3단까지만 사용하던 기존 요청은 그대로 동작합니다.
            </>
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.2',
            detail:
            <>
              <b>온라인상품 수정</b> 요청에 옵션명 <code>opt_sort4</code>·<code>opt_sort5</code>, 옵션값 <code>opt_sort4_desc</code>·<code>opt_sort5_desc</code> 가 추가되었습니다. 쇼핑몰별 옵션 단계 제한은 등록과 동일하게 적용됩니다.
            </>
          },
          {
            method: 'POST',
            action: '/product/online/list/v1.2',
            detail:
            <>
              <b>온라인상품 리스트 조회</b> Response 에 옵션명 <code>opt_sort4</code>·<code>opt_sort5</code>, 옵션값 <code>opt_name4</code>·<code>opt_name5</code> 가 추가되었습니다.
            </>
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.2',
            detail:
            <>
              <b>온라인상품 상세 조회</b> Response 에 옵션명 <code>opt_sort4</code>·<code>opt_sort5</code>, 옵션값 <code>opt_sort4_desc</code>·<code>opt_sort5_desc</code> 및 옵션 정보 배열의 <code>opt_name4</code>·<code>opt_name5</code> 가 추가되었습니다.
            </>
          },
          {
            method: 'POST',
            action: '/stock/add/v1.2',
            detail:
            <>
              <b>SKU상품 등록</b> 요청의 속성이 3단에서 5단으로 확장되어 <code>opt3_type</code>·<code>opt3</code>, <code>opt4_type</code>·<code>opt4</code>, <code>opt5_type</code>·<code>opt5</code> 파라미터가 추가되었습니다.<br />
              - 추가된 속성은 모두 선택 입력값이며, 기존 요청은 그대로 동작합니다.
            </>
          },
          {
            method: 'PUT',
            action: '/stock/edit/v1.2',
            detail:
            <>
              <b>SKU상품 수정</b> 요청에 속성 <code>opt4_type</code>·<code>opt4</code>, <code>opt5_type</code>·<code>opt5</code> 파라미터가 추가되었습니다.
            </>
          },
          {
            method: 'POST',
            action: '/stock/list/v1.2',
            detail:
            <>
              <b>SKU상품 리스트 조회</b> Response 의 <code>options</code> 속성 배열(<code>attri</code>·<code>attri_type</code>)에 4·5단 속성까지 반환됩니다.
            </>
          },
          {
            method: 'GET',
            action: '/stock/:sku_cd/v1.2',
            detail:
            <>
              <b>SKU상품 상세 조회</b> Response 의 <code>options</code> 속성 배열(<code>attri</code>·<code>attri_type</code>)에 4·5단 속성까지 반환됩니다.
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-10-07',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API Response <code>pa_addcol_directDelivery</code>(배송유형 구분) 값 추가 및 타입 변경
        </>,
        apis: [
          {
            authorized_aff_no: [1208],
            method: 'POST',
            action: '/orders',
            detail:
            <>
              - 타입: <code>String(1)</code> → <code>Number(1)</code><br />
              - 값: <code>1</code>(직택배), <code>null</code>(일반)에 <code>2</code>(직납(자체배송)) 추가<br />
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-09-30',
    items: [
      {
        type: 'Added',
        summary:
        <>
          주문상태변경 API v1.1 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/order/status/v1.1',
            detail:
            <>
              v1.0 버전과의 차이점<br/>
              - 변경하려고 하는 주문상태(<code>status</code>) 값별로 변경 가능한 현재 주문상태 범위가 확장되었습니다.<br/>
              - 클레임 완료 상태(취소완료/반품회수완료/반품완료/교환회수완료/교환완료/맞교환완료) 및 배송/구매 완료 상태에서도 다른 주문상태로 변경할 수 있습니다.<br/>
              - 예) [신규주문]은 현재 주문상태가 <code>주문재확인, 주문보류, 출고대기, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료</code>인 경우 변경 가능합니다.<br/>
              - 주문 동기화 시 쇼핑몰 상태를 기준으로 주문 상태가 변경될 수 있으므로 사용 시 주의하시기 바랍니다.
            </>
          }
        ]
      },
      {
        type: 'Added',
        summary:
        <>
        상품리스트 조회/상세조회/상품등록/수정 API에 <b>상품 단위 가격</b> 항목이 추가되었습니다. <br /><br />
        기존 단위 가격은 옵션(<code>opts</code>) 하위에만 있었으나, 옵션과 별개로 상품 단위 가격을 최상위에서 입력·조회할 수 있습니다. <br /><br />
        [추가] <br /> - 단위 가격 표시 여부 <code>unit_price_yn</code>,<br />
        - 단위 가격 표시 용량 <code>unit_capacity</code>,<br /> - 단위 가격 표시 단위 <code>indication_unit</code>,<br />
        - 단위 가격 구성 방식 <code>unit_price_type</code>(낱개/팩),<br /> - 단위 가격 팩 수량 <code>unit_price_pack_qty</code>,<br />
        - 단위 가격 팩당 수량 <code>unit_price_item_qty</code>,<br /> - 단위 가격 팩당 수량 단위 <code>unit_price_item_qty_unit</code>(지그재그 채널 전송 시에만 사용),<br />
        - 단위 가격 개당 용량 <code>item_capacity</code> <br /><br />
        옵션 단위 가격은 기존과 동일하며 <code>opts</code> 하위에서 계속 사용합니다. 파라미터명이 상품과 동일하므로 설명에 <code>opts.</code> 를 함께 표기했습니다.
        </>,
        apis: [
          {
            method: 'POST',
            action: 'product/online/list/v1.2',
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.2',
          },
          {
            method: 'POST',
            action: '/products/add/v1.2',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2026-08-26',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 상세 조회 API Response에 적용된 규칙사은품 <code>gift_rule</code> 추가<br/>
          - 기존 주문 리스트 조회 API와 동일하게 상세 조회에서도 규칙 적용 사은품 정보를 확인할 수 있습니다.
        </>,
        apis: [
          {
            method: 'GET',
            action: '/order/:uniq',
            detail:
            <>
              - order_data 내 <code>gift_rule</code> 추가 (묶음 주문은 적용된 규칙 사은품이 각 주문 별로 모두 출력됩니다.)<br/>
              - <code>gift_rule</code> 하위 필드: <code>name</code>(사은품명), <code>sku_cd</code>(sku 코드), <code>count</code>(사은품 출고갯수), <code>gift_name</code>(제공 사은품명), <code>gift_rule_name</code>(사은품 규칙명)<br/>
            </>
          }
        ]
      }
    ]
  },
    {
    date: '2026-08-12',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          상품리스트 조회/상세조회/상품등록/수정 API 단위 가격 항목이 개선되었습니다. <br /><br />
          [추가] <br /> - 단위 가격 구성 방식 <code>unit_price_type</code>(낱개/팩),<br />
          - 단위 가격 팩 수량 <code>unit_price_pack_qty</code>,<br /> - 단위 가격 팩당 수량 <code>unit_price_item_qty</code>,<br />
          - 단위 가격 팩당 수량 단위 <code>unit_price_item_qty_unit</code>(지그재그 채널 전송 시에만 사용),<br /> - 단위 가격 개당 용량 <code>item_capacity</code> <br /><br />
          [변경] <br /> - 단위 가격 총 용량 <code>total_capacity</code> 사용 중단(Deprecated)<br />
          총 용량은 팩 수량 × 팩당 수량 × 개당 용량 계산값으로 전환되어 더 이상 입력하지 않습니다. 구버전 호환을 위해 입력 시 개당 용량(<code>item_capacity</code>)으로 처리되며, 조회 응답에는 포함되지 않습니다.
        </>,
        apis: [
          {
            method: 'POST',
            action: 'product/online/list/v1.2',
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.2',
          },
          {
            method: 'POST',
            action: '/products/add/v1.2',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.2',
          }
        ]
      }
    ]
  },
    {
      date: '2026-08-12',
      items: [
        {
          type: 'Changed',
          summary:
          <>
            주문 리스트 조회 API에 배송속성 필터 파라미터 추가<br/>
            주문 리스트/상세 조회 Response에 배송속성 <code>ship_ser_name</code> 추가<br/>
            - 배송속성 종류: 당일발송, 당일택배, 도착보장, 스타배송, 오늘출발
          </>,
          apis: [
            {
              method: 'POST',
              action: '/orders',
              detail:
              <>
                <strong>요청 파라미터 추가</strong><br/>
                - <code>ship_ser_yn</code> : 배송속성 여부 (<code></code> 전체 / <code>1</code> 있음 / <code>0</code> 없음)<br/>
                - <code>ship_ser_name</code> : 배송속성 선택 (<code>ship_ser_yn</code>이 <code>1</code>일 때만 적용, 특정 배송속성 주문만 필터링)<br/>
                <strong>Response 추가</strong><br/>
                - results 내 <code>ship_ser_name</code> (배송속성) 추가. 값이 없는 경우 공란<br/>
              </>
            },
            {
              method: 'GET',
              action: '/order/:uniq',
              detail:
              <>
                <strong>Response 추가</strong><br/>
                - order_data 내 <code>ship_ser_name</code> (배송속성) 추가. 값이 없는 경우 공란<br/>
              </>
            }
          ]
        }
      ]
    },
    {
    date: '2026-05-11',
    items: [
      {
        type: 'Added',
        summary:
        <>
          재고수정 API v1.2 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/api/stock/manage/v1.2',
            detail:
            <>
              - 솔루션 환경설정 &gt; 상품 자동 품절을 사용하고 SKU상품의 상태가 재고 부족 또는 품절로 변경되는 경우, 연동된 온라인 상품을 쇼핑몰에 자동으로 품절 전송<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-29',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          SKU상품/온라인상품/주문 상품명 허용 범위 확대
        </>,
        apis: [
          {
            method: 'POST',
            action: '/api/stock/add',
          },
          {
            method: 'PUT',
            action: '/api/stock/edit',
            detail:
            <>
              - SKU상품명(<code>prod_name</code>) 입력 시 기존 허용 문자 제한을 해제, <code>|</code>, <code>#</code>, 4byte 이모지(지원하지 않는 이모티콘)를 제외한 문자 입력을 허용.<br/>
            </>
          },
          {
            method: 'POST',
            action: '/api/products/add',
          },
          {
            method: 'PUT',
            action: '/api/products/edit',
            detail:
            <>
              - 상품명(<code>shop_sale_name</code>) 입력 시 기존 허용 문자 제한을 해제, <code>|</code>, <code>#</code>, 4byte 이모지(지원하지 않는 이모티콘)를 제외한 문자 입력을 허용.<br/>
            </>
          },
          {
            method: 'POST',
            action: '/order/add',
          },
          {
            method: 'PUT',
            action: '/order/edit',
            detail:
            <>
              - 주문상품명(<code>shop_sale_name</code>) 입력 시 기존 허용 문자 제한을 해제, <code>|</code>, <code>#</code>, 4byte 이모지(지원하지 않는 이모티콘)를 제외한 문자 입력을 허용.<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-22',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          [재고/SKU상품 등록] 바코드 입력 허용 문자 범위 확대
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/add/v1.2',
            detail:
            <>
              - <strong>기존</strong> : 영문, 숫자, 띄어쓰기, _만 입력 가능<br/>
              - <strong>변경</strong> : 영문, 숫자, 띄어쓰기와 특수문자 ( ) - _ = + . / , 도 입력 가능<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-20',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 상태 변경 가능 조건 확장
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - <strong>취소요청</strong> : 현재 주문상태가 [주문재확인]인 경우 변경 가능<br/>
              - <strong>취소완료</strong> : 현재 주문상태가 [주문재확인, 취소요청]인 경우 변경 가능<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-13',
    items: [
      {
        type: 'Added',
        summary:
        <>
          입출고 내역 조회 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stocks/inout',
            detail:
            <>
              <strong>입출고 내역 조회 추가</strong><br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-03',
    items: [
      {
        type: 'Changed',  
        summary:
        <>
          주문리스트 조회 API Response 내 오늘출발 주문 여부 <code>is_send_today</code> 추가<br/>
          - 지원 쇼핑몰: 쿠팡, 옥션, 지마켓, 11번가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          },
        ]
      }
    ]
  },
  {
    date: '2026-03-31',
    items: [
      {
        type: 'Changed',  
        summary:
        <>
          상품리스트 조회/상세조회/상품등록/수정 API 파라미터에 아래 필드 추가 <br /><br /> - 단위 가격 표시 여부 <code>unit_price_yn</code>,<br />
          - 단위 가격 총 용량 <code>total_capacity</code>,<br /> - 단위 가격 표시 용량 <code>unit_capacity</code>,<br /> - 단위 가격 표시 단위 <code>indication_unit</code>
        </>,
        apis: [
          {
            method: 'POST',
            action: 'product/online/list/v1.2',
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.2',
          },
          {
            method: 'POST',
            action: '/products/add/v1.2',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2026-03-30',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          데이터 정확성 유지 및 정책 기준 반영 위해
          주문 리스트 조회 & 주문 상세 조회 API 응답값 내 국내 주문 가격 반올림 처리 및 클레임 주문 건 가격 & 출고 수량 등 값 변경
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail:
            <>
              <strong>주문리스트 조회 시</strong><br/>
              - results 내 <code>sales ship_cost shop_cost_price shop_supply_price pay_amt discount_amt shop_discount seller_discount coupon_discount point_discount</code> 해당 필드 반올림 제거<br/>
              <strong>클레임 주문 건 ('취소완료', '반품완료', '교환완료', '맞교환완료') 일 경우</strong><br/>
              - results 내 <code>sale_cnt sales shop_supply_price shop_cost_price ship_cost pay_amt discount_amt out_cnt pack_unit</code> 0 처리<br/>
              - results_prod 내 <code>opt_sale_cnt</code> 0 처리<br/>
            </>
          },
          {
            method: 'GET',
            action: '/order/:uniq',
            detail:
            <>
              <strong>주문 상세 조회 시</strong><br/>
              - order_data 내 <code>sales ship_cost shop_cost_price shop_supply_price pay_amt discount_amt shop_discount seller_discount coupon_discount point_discount sale_price</code> 해당 필드 반올림 제거<br/>
              <strong>클레임 주문 건 ('취소완료', '반품완료', '교환완료', '맞교환완료') 일 경우</strong><br/>
              - order_data 내 <code>sale_cnt sales shop_supply_price shop_cost_price ship_cost pay_amt discount_amt out_cnt pack_unit</code> 0 처리<br/>
              - prod_list 내 <code>opt_sale_cnt</code> 0 처리<br/>
              - ord_opt_list 내 <code>opt_sale_cnt sale_price</code> 0 처리<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-03-17',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 파라미터 <code>fulfillment_type</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail:
            <>
              - 기존 <code>fulfillment_yn</code>(boolean)으로는 물류/일반 통합 조회가 불가했던 점을 개선하여 <code>fulfillment_type</code> 파라미터를 신설<br/>
              - <code>fulfillment_type: "all"</code> 입력 시 물류 배송 + 일반 배송 주문을 모두 조회 가능<br/>
              - 기존 <code>fulfillment_yn</code>은 하위 호환을 위해 유지, <code>fulfillment_type</code> 입력 시 <code>fulfillment_type</code>이 우선 적용됨<br/>
              - 응답값에 <code>ship_type</code> 필드 추가 (<code>물류배송</code> / <code>일반배송</code> / <code>배송없음</code>)
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-25',
    items: [
      {
        type: 'Changed',  
        summary:
        <>
          SKU상품-리스트 조회/상세조회/등록, 세트상품-조회/등록 API 파라미터 출고 리드타임 <code>out_leadtime</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/set-add',
          },
          {
            method: 'POST',
            action: '/stock/sets',
          },
          {
            method: 'POST',
            action: '/stock/add',
          },
          {
            method: 'GET',
            action: '/stock/:sku_cd',
          },
          {
            method: 'POST',
            action: '/stock/list',
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-12',
    items: [
      {
        type: 'Changed',
        summary: 
        <>
          주문 리스트조회 API Response 귀책 구분 <code>claim_fault_type</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-11',
    items: [
      {
        type: 'Added',
        summary:
        <>
          선택작업 등록 API v1.1 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect/v1.1',
            detail: 
            <>
              v1.0 버전과의 차이점<br/>
              - 쇼핑몰 상품 연동 작업시 호출하는 파라미터에 <code>shop_cd, shop_id, std_ol_yn</code> 제거.<br/>
              - 쇼핑몰 상품 연동 작업시 list 파라미터에 <code>c_sale_cd</code> 가 아닌 <code>ol_shop_no</code> 사용<br/>
              - 나머지는 v1.0 과 동일
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-02',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          배송정보 업데이트 API 파라미터 검증 강화
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/setInvoice',
            detail:
            <>
              - 배송정보 업데이트 API 요청 시 orders 내부 타입이 유효하지 않은 경우 오류가 반환되도록 개선되었습니다.
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-01-21',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 상태 변경 가능 조건 확장
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - <strong>배송중</strong> : 현재 주문상태가 [주문재확인, <strong>출고완료</strong>]인 경우 변경 가능<br/>
            </>
          }
        ]
      }
    ]
  }
]

export default release2026;
